import { useTranslation } from "react-i18next";
import { MotionReveal } from "./MotionReveal";

export function Footer() {
  const { t } = useTranslation("global");

  return (
    <MotionReveal as="footer" className="siat-footer">
      <p>{t("footer.tagline")}</p>
      <a href="https://www.siat-app.com" rel="noopener noreferrer">
        {t("footer.url")}
      </a>
    </MotionReveal>
  );
}
